export default "__VITE_ASSET__D$_UYgVa__"